import React, { FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HotelFilterContext } from 'contexts/HotelFilterContext';
import Checkbox from 'components/ui/Checkbox/Checkbox';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { formatPriceCurrency, getCurrency } from 'utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faTimes } from '@fortawesome/free-solid-svg-icons';
import { getKey } from 'utils/hotel';
import { useClickAway } from 'hooks/useClickAway';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { HotelConfigContext } from 'contexts/HotelConfigContext';

interface FilterSupplierProps {
  onFilterChange: (FilterModel: any) => void;
}

const FilterSupplier: FC<FilterSupplierProps> = (props) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { filter } = useContext(HotelFilterContext);
  const { hotelIndex } = useContext(HotelConfigContext);
  const currency = sessionStorage.getItem(getKey('displayCurrencyHotels', hotelIndex)) || 'usd';
  const suppRef = useClickAway(() => {
    setOpen(false);
  });

  const onChange = (val: boolean, index: number) => {
    const newFilter = { ...filter! };
    newFilter.suppliers[index].checked = val;
    props.onFilterChange(newFilter);
  };

  const showClear = () => {
    return filter?.suppliers.some((sup) => sup.checked);
  };

  const onClickClear = () => {
    const newFilter = { ...filter! };
    newFilter.suppliers.forEach((sup) => (sup.checked = false));
    props.onFilterChange(newFilter);
  };

  return (
    <div className="hotel-result-filter-input supp">
      <Tooltip content={t('hotel.supplier')} position="top">
        <div className="form-control cur-poi" onClick={() => setOpen(!open)}>
          <FontAwesomeIcon icon={faList} />
        </div>
      </Tooltip>

      {open && (
        <div className="dp-wrapper dp3-wrapper" ref={suppRef}>
          {showClear() && (
            <span className="flex-row-end ph-10 mb-5">
              <span className="text-sm color-danger cur-poi" onClick={onClickClear}>
                <FontAwesomeIcon icon={faTimes} /> {t('clear')}
              </span>
            </span>
          )}

          {!!filter?.suppliers?.length && (
            <table className="hotel-supplier-table">
              <thead>
                <tr>
                  <th>{t('hotel.supplier')}</th>
                  <th>{t('hotel.s')}</th>
                  <th>{t('hotel.rooms')}</th>
                  <th>{t('price')}</th>
                </tr>
              </thead>
              <tbody>
                {filter.suppliers.map((sup, index) => (
                  <tr key={index}>
                    <td>
                      <Checkbox
                        checked={sup.checked}
                        label={sup.suppDesc || sup.suppCode}
                        onChange={(val: boolean) => onChange(val, index)}
                      />

                    </td>

                    <td className="mr-5">{sup.hotels}</td>
                    <td className="mr-5">{sup.rooms}</td>
                    <td>({formatPriceCurrency(sup.price, getCurrency(currency))})</td>
                  </tr>
                ))}
                <tr className="text-bold pt-10">
                  <td className="mt-5">{t('total')}:</td>
                  <td>{filter.suppliers.reduce((acc, sup) => sup.hotels + acc, 0)}</td>
                  <td>{filter.suppliers.reduce((acc, sup) => sup.rooms + acc, 0)}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(FilterSupplier, 'FilterSupplier');
